<template>
    <div class="reaction-section d-flex justify-content-end">
        <template v-if="idConversa == 0">
            <div class="btn-grp">
                <div :class="'dropup ' + ( !top? 'left-side-btn ':'')">
                    <!--<button data-bs-toggle="modal" data-bs-target="#shareModal"
                            class="react-btn btn-default btn-small btn-border">
                        <i class="feather-share"></i>
                    </button>-->
                    <button type="button" class="react-btn btn-default btn-small btn-border dropdown-toggle btn-sollai d-flex justify-content-center align-items-center"
                            data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="feather-more-vertical"></i> Opções <!--<i class="feather-more-vertical"></i>-->
                    </button>
                    <ul class="dropdown-menu">
                        <li>
                            <a class="dropdown-item" href="javascript:void(0)" @click="imprimir"><i class="feather-file-text"></i> Imprimir</a>
                        </li>
                        <li>
                            <a class="dropdown-item" href="javascript:void(0)" @click="imprimir"><i class="feather-file-text"></i> Baixar PDF</a>
                        </li>
                        <li>
                            <a class="dropdown-item" href="javascript:void(0)" @click="word"><i class="feather-file-text"></i> Baixar Word</a>
                        </li>
                    </ul>
                </div>
                <div class="right-side-btn">
                    <button class="react-btn btn-default btn-small btn-border "  @click="proximo" v-if="!disabled">
                        <i></i><span>Selecionar</span>
                    </button>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="btn-grp justify-content-center">
                <div class="dropup">
                    <!--<button data-bs-toggle="modal" data-bs-target="#shareModal"
                            class="react-btn btn-default btn-small btn-border">
                        <i class="feather-share"></i>
                    </button>-->
                    
                    <button type="button" class="react-btn btn-default btn-small btn-border dropdown-toggle btn-sollai d-flex justify-content-center align-items-center"
                            data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="feather-more-vertical"></i> Opções
                    </button>
                    <ul class="dropdown-menu">

                        <li>
                            <a class="dropdown-item" href="javascript:void(0)" @click="imprimir"><i class="feather-file-text"></i> Imprimir</a>
                        </li>
                        <li>
                            <a class="dropdown-item" href="javascript:void(0)" @click="imprimir"><i class="feather-file-text"></i> Baixar PDF</a>
                        </li>
                        <li>
                            <a class="dropdown-item" href="javascript:void(0)" @click="word"><i class="feather-file-text"></i> Baixar Word</a>
                        </li>
                    </ul>
                </div>
            </div>
        </template>
    </div>
</template>

<script>

    export default {
        name: 'ReactionSection',
        components: {},
        props: {
            idConversa: Number,
            imprimir: Function,
            word: Function,
            proximo: Function,
            disabled: Boolean,
            top: Boolean,
        },
        computed: {
            
        },
        data: function () {
            return {
                
            }
        },
        methods: {
            
        },
        mounted: function () {
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>

